$(".top-header-slider").slick({
  autoplay: true,
  autoplaySpeed: 0,
  speed: 6000,
  arrows: false,
  swipe: false,
  slidesToShow: 2,
  cssEase: "linear",
  pauseOnFocus: false,
  pauseOnHover: false,
  variableWidth: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        speed: 26000,
      },
    },
  ],
});

$(".hero-slider").slick({
  dots: true,
  number:false,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  arrows: true,
  autoplay: true,
  autoplaySpeed: 3000,
  prevArrow:
    '<button class="slide-arrow prev-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M7.825 13L13.425 18.6L12 20L4 12L12 4L13.425 5.4L7.825 11H20V13H7.825Z" fill="#D6B369"></path></svg></button>',
  nextArrow:
    '<button class="slide-arrow next-arrow"><svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><path d="M7.825 13L13.425 18.6L12 20L4 12L12 4L13.425 5.4L7.825 11H20V13H7.825Z" fill="#D6B369"></path></svg></button>',
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
      },
    },
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 1, // Ensure only 1 slide is shown
        slidesToScroll: 1, // Ensure only 1 slide is scrolled
        autoplay: true,
      },
    },
  ],
});


 $('.logo-slider').slick({
      slidesToShow: 5,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      arrows: false,
      dots: false,
      pauseOnHover: false,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 4 }},
        { breakpoint: 768, settings: { slidesToShow: 3 }},
        { breakpoint: 480, settings: { slidesToShow: 2 }}
      ]
    });

$('.testimonials-slider').slick({
  slidesToShow: 4,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
  arrows: false,
  dots: true,
   draggable: true, // allow mouse drag on desktop
  swipe: true,     // allow touch swipe
  responsive: [
    { breakpoint: 1200, settings: { slidesToShow: 2 }}, // covers <=1200px
    { breakpoint: 768, settings: { slidesToShow: 1 }}
  ]
});


       document.addEventListener('DOMContentLoaded', function () {
        const tabs = document.querySelectorAll('.tab-link');
        const contents = document.querySelectorAll('.tab-content');

        tabs.forEach((tab) => {
          tab.addEventListener('click', () => {
            const target = tab.dataset.tab;

            tabs.forEach((t) => t.classList.remove('active'));
            tab.classList.add('active');

            contents.forEach((c) => {
              c.classList.remove('active');
              if (c.id === target) c.classList.add('active');
            });
          });
        });
      });




document.addEventListener("DOMContentLoaded", function() {
  const galleryContainer = document.querySelector(".product__media-wrapper"); // adjust selector to your theme
  
  document.querySelectorAll("input[name='color-swatch']").forEach(function(input) {
    input.addEventListener("change", function() {
      const gallery = JSON.parse(this.dataset.gallery || "[]");
      
      if (gallery.length && galleryContainer) {
        galleryContainer.innerHTML = ""; // clear existing images

        gallery.forEach(function(imgUrl) {
          const imgEl = document.createElement("img");
          imgEl.src = imgUrl;
          imgEl.loading = "lazy";
          imgEl.classList.add("product-media-image");
          galleryContainer.appendChild(imgEl);
        });
      }
      
      // Update the selected color text
      const selectedSpan = document.querySelector("legend span[data-selected-value]");
      if (selectedSpan) selectedSpan.textContent = this.value;
    });
  });
});

document.addEventListener("DOMContentLoaded", function () {
  const variantDropdowns = document.querySelectorAll(".variant-select");

  variantDropdowns.forEach((dropdown) => {
    dropdown.addEventListener("change", function () {
      const selectedOption = this.options[this.selectedIndex];

      const price = selectedOption.getAttribute("data-price");
      const comparePrice = selectedOption.getAttribute("data-compare");

      const card = this.closest(".card__content");

      if (card) {
        const priceWrapper = card.querySelector(".price-wrapper");

        if (priceWrapper) {
          let priceHTML = "";

          // Show compare-at price first if it exists and is different
          if (comparePrice && comparePrice !== "$0.00" && comparePrice !== price) {
            priceHTML += `<span class="compare-price price--on-sale price-item--regular"><s>${comparePrice}</s></span> `;
          }

          // Then show main price
          priceHTML += `<span class="price price-item--sale">${price}</span>`;

          priceWrapper.innerHTML = priceHTML;
        }
      }
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
  const form = document.querySelector('[data-testid="form"]');

  const phone = document.querySelector('[id="phone_number"]');
  const altPhone = document.querySelector('[id="custom#alternate_number"]');
  const pincode = document.querySelector('[id="custom#pincode"]');  // FIXED SELECTOR

  form.addEventListener("submit", function (e) {
    let valid = true;

    // reset borders
    [phone, altPhone, pincode].forEach(f => f.style.border = "1px solid #ccc");

    // Phone number validation (required)
    const phoneRegex = /^[0-9]{10}$/;
    if (!phoneRegex.test(phone.value.trim())) {
      valid = false;
      phone.style.border = "1px solid red";
      alert("Phone number must be exactly 10 digits.");
    }

    // Alternate number validation (optional)
    if (altPhone.value.trim() !== "" && !phoneRegex.test(altPhone.value.trim())) {
      valid = false;
      altPhone.style.border = "1px solid red";
      alert("Alternate number must be exactly 10 digits.");
    }

    // Pincode validation — 6 digits only
    const pinRegex = /^[0-9]{6}$/;
    if (!pinRegex.test(pincode.value.trim())) {
      valid = false;
      pincode.style.border = "1px solid red";
      alert("Pincode must be exactly 6 digits.");
    }

    if (!valid) {
      e.preventDefault();
    }
  });

  // Restrict typing to correct lengths
  phone.addEventListener("input", function () {
    this.value = this.value.replace(/\D/g, "").slice(0, 10);
  });

  altPhone.addEventListener("input", function () {
    this.value = this.value.replace(/\D/g, "").slice(0, 10);
  });

  pincode.addEventListener("input", function () {
    this.value = this.value.replace(/\D/g, "").slice(0, 6);
  });
});


document.addEventListener("click", function (e) {
  let btn = e.target.closest("[data-option-select]");
  if (!btn) return;

  let form = btn.closest("[data-product]");
  if (!form) return;

  let productId = form.dataset.product;

  let group = btn.closest(".variant-group");
  let optionIndex = group.dataset.optionIndex;
  let value = btn.dataset.value;

  // Highlight selected button
  group.querySelectorAll("[data-option-select]").forEach(b => b.classList.remove("active"));
  btn.classList.add("active");

  // Store selection temporarily
  if (!form.selectedOptions) form.selectedOptions = [];
  form.selectedOptions[optionIndex] = value;

  // Find matching variant
  let variants = window.productVariants[productId];
  if (!variants) return;

  let matchedVariant = variants.find(v =>
    v.options.every((opt, index) => opt == form.selectedOptions[index])
  );

  // Update hidden input
  if (matchedVariant) {
    form.querySelector(".variant-id-input").value = matchedVariant.id;
  }
});


document.addEventListener("DOMContentLoaded", function() {
  function fixButton() {
    const btns = document.querySelectorAll(".df-btn");
    btns.forEach(btn => {
      btn.style.setProperty("bottom", "66px", "important");
      btn.style.setProperty("right", "12px", "important");
   
    });
  }

  // Run on page load
  fixButton();

  // Run again if Shopify dynamically reloads content
  const observer = new MutationObserver(fixButton);
  observer.observe(document.body, { childList: true, subtree: true });
});

